/* eslint-disable react/prop-types */
import React from 'react';
import Empty from 'Assets/images/pages/web-chat/empty.png';

function EmptyList({ text }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        rowGap: '32px',
        marginTop: '32px',
      }}>
      <img src={Empty} alt="empty-list" width="192px" height="192px" />
      {text}
    </div>
  );
}

export default EmptyList;
